"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_calendar__18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dbc378e6-1555-4fe3-9d96-688630562b21",
    x1: 59.82,
    y1: 28.29,
    x2: 179.23,
    y2: 147.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "calendar-18-hi"), /*#__PURE__*/React.createElement("g", {
    id: "a2748160-e3c1-4304-ba0e-29a13a4173b4",
    "data-name": "calendar-18-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e9630796-9637-4f6f-a2f7-d65ac6a6c762",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "45c342c3-35b4-4de0-958c-1ea6a282dc2e",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0a5a32e3-a31f-4c0c-aa4f-e8291cae9e29",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a7450680-3ac1-4b58-ac6a-fe626f7f828c",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b8ce72a1-40db-4b28-9f11-65304aa8e502",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b3469286-8ca3-4dfb-9328-db2463cbf1c4",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ba8b6cb4-5590-40ef-9281-5275c334af59",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,152a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16V64H24Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,166H40a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16v-2A16,16,0,0,1,152,166Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,24H32a8,8,0,0,0-8,8V64H168V32A8,8,0,0,0,160,24ZM52,40a4,4,0,1,1,4-4A4,4,0,0,1,52,40Zm88,0a4,4,0,1,1,4-4A4,4,0,0,1,140,40Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 62,
    width: 144,
    height: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,30a4,4,0,0,0-3.86,5,4,4,0,0,1,7.72,0A4,4,0,0,0,52,30Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,30a4,4,0,0,0-3.86,5,4,4,0,0,1,7.72,0A4,4,0,0,0,140,30Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "47cddb8c-71e1-4c42-8d62-100e0a14ef5c",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.51,64.13l-123.33-.2h-20v.59L128.34,168H152a19,19,0,0,0,4.24-.37,16.3,16.3,0,0,0,8.52-5.64,15.86,15.86,0,0,0,3.39-9.81V64.79Z",
    transform: "translate(0 0)",
    opacity: 0.1,
    fill: "url(#dbc378e6-1555-4fe3-9d96-688630562b21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.89,24.63A7.92,7.92,0,0,1,31.19,24,7.92,7.92,0,0,0,28.89,24.63Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.54,25.37a8.1,8.1,0,0,0-1.7,1.55A8.1,8.1,0,0,1,27.54,25.37Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  })))))))), /*#__PURE__*/React.createElement("path", {
    d: "M74.35,137.46V92.09L63,99.74l-3-4.38L75.15,84.83h5.34v52.62Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.41,138.5a18.3,18.3,0,0,1-5.82-1,14.73,14.73,0,0,1-5.1-2.91,14.92,14.92,0,0,1-3.63-4.86,15.41,15.41,0,0,1-1.4-6.74,16.09,16.09,0,0,1,1.79-7.58,13,13,0,0,1,5.46-5.42,15.42,15.42,0,0,1-4.7-5.26A13.85,13.85,0,0,1,100.27,98a13.07,13.07,0,0,1,2.79-8.53,13.51,13.51,0,0,1,6.18-4.54,19.91,19.91,0,0,1,6.18-1.12,16.18,16.18,0,0,1,8.17,2.07,12.74,12.74,0,0,1,5.22,5.18,14.15,14.15,0,0,1,1.59,6.54,14.35,14.35,0,0,1-1.71,7,17.11,17.11,0,0,1-4.58,5.38,12.09,12.09,0,0,1,5.3,5.38,16.64,16.64,0,0,1,1.79,7.61,15,15,0,0,1-2.87,9.45,13.81,13.81,0,0,1-6.42,4.9A20.52,20.52,0,0,1,115.41,138.5Zm0-5.5a10.56,10.56,0,0,0,5.42-1.4,8.37,8.37,0,0,0,3.47-3.67,11.13,11.13,0,0,0,1.08-4.82,10.08,10.08,0,0,0-1.79-6,9.59,9.59,0,0,0-4.15-3.47,11.18,11.18,0,0,0-4.11-1,9.76,9.76,0,0,0-5.5,1.63,9.33,9.33,0,0,0-3.51,3.95,11.39,11.39,0,0,0-1,4.7,9.71,9.71,0,0,0,1.83,6,8.91,8.91,0,0,0,4.11,3.23A12.71,12.71,0,0,0,115.41,133Zm-.08-25.52a9.36,9.36,0,0,0,8.21-5.1,10.33,10.33,0,0,0,1-4.39,8.39,8.39,0,0,0-1.59-5.26,8.14,8.14,0,0,0-3.75-2.83,11.56,11.56,0,0,0-3.75-.76,9.91,9.91,0,0,0-5.1,1.36,7.69,7.69,0,0,0-3.23,3.31,9.72,9.72,0,0,0-.92,4.19,10,10,0,0,0,.8,4.11,8.75,8.75,0,0,0,5.06,4.78A9.57,9.57,0,0,0,115.34,107.48Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  })));
}

var _default = ic_calendar__18;
exports.default = _default;